window.popUp = function (url) {
	window.open(url, "Generate", "menubar=0,status=0,scrollbars=1,resizable=1,toolbar=0,location=0,width=1040,height=650")
}

$(window).bind('load', function(event) {
	$('#lnkLanguageSelection, #close_languageSelection').bind('click', function(evt) {
		$('#languageSelection').toggle();
		evt.preventDefault();
	});

	$('#lnkScreenSizeSelection, #close_screenSizeSelection').bind('click', function (evt) {
		$('#screenSizeSelection').toggle();
		evt.preventDefault();
	});

	$('#lnkCustomHtmlToggle, #close_customHTMLToggle').bind('click', function (evt) {
		$('#customHTMLToggle').toggle();
		evt.preventDefault();
	});

	$('#lnkReports').bind('click', function (evt) {
		DUIframe.open({
			url: '../admin/portaltabs/index?iframe=true'
		});
		$('#DUIframeContainer').css('zIndex', 9999);
		evt.preventDefault();
	});

	$('#lnkMyExportsPage, #lnkMyExportsPageLink').bind('click', function (evt) {
		$("#close_downloadSelectedPowerpoint").click();
		DownloadArea.clearExportProgress();
		DUIframe.open('../ReportDistributionModule/MyExports.aspx');
		evt.stopPropagation();
		evt.preventDefault();
	});
});

$(function() {
	$("#lnkMyExportsPage").text(locale.get("My exports page", 0));
	if ((window.IsStoryboard && window.ContentType < 1) ||
        (window.IsStoryboard && window.ContentType === Storyboard.Constants.itemTypes.CHART) ||
		window.IsFormReport || window.IsMyStories) {
			DownloadArea.showExports();
		}

	if (typeof ToggleAdvancedMode != 'undefined')
		ToggleAdvancedMode(false);

	////////// Presentation Mode

	var $pageWrapper = $("#pageWrapper"),
		toggleSetContainer,
		$presentationCtrls = $('<div id="presentationControls"></div>').appendTo($pageWrapper);

	$presentationCtrls.append('<button type="button" class="togglePresentation"></button>');

	$presentationCtrls.find('.togglePresentation').click(function () {
		$pageWrapper.toggleClass('presentation-mode');
		$pageWrapper.find('#header, #poweredby').slideToggle();
		if (typeof (window.toggleSet) != 'undefined') {
			var toggleState = $pageWrapper.hasClass('presentation-mode') ? 'Off' : 'On';
			window.toggleSet.toggle(toggleState);
		}
	});


	var ToggleSettings = function (settingsContainer) {
		this.settContainer = settingsContainer;
		this.elContainer = $presentationCtrls;
		this.toggleEl = 0;
		this.toggleState = 1;
	};

	ToggleSettings.prototype.init = function () {

		var settingsButtonExists = $('.toggleFilters').length > 0;

		if (!settingsButtonExists) {
			var _that = this;
			this.toggleState = 1;
			this.elContainer.append('<button type="button" title="Filters" class="toggleFiltersMaster">');
			this.toggleEl = $('.toggleFiltersMaster').bind('click', function (e) {
				e.preventDefault();
				_that.toggle();
			});
		}

	}

	ToggleSettings.prototype.toggleOff = function () {
		var $settContainer = $(this.settContainer);
		$settContainer.slideUp('fast', function () {
			$(this).addClass('toggleOff');
		});

		$pageWrapper.addClass('settings-hidden');
		this.toggleEl.addClass('filtersoff');
		this.toggleState = 0;
	}

	ToggleSettings.prototype.toggleOn = function () {
		var $settContainer = $(this.settContainer);
		$settContainer.slideDown('fast', function () {
			$(this).removeClass('toggleOff');
		});

		$pageWrapper.removeClass('settings-hidden');
		this.toggleEl.removeClass('filtersoff');
		this.toggleState = 1;
	}

	ToggleSettings.prototype.toggle = function (state) {
		if (typeof (state) != 'undefined') {
			this['toggle' + state]();
		} else {
			this['toggle' + (this.toggleState == 0 ? 'On' : 'Off')]();
		}
	}

	function staticToggleTools(sender, args) {
		if (typeof (toggleSet) == 'undefined') {
			window.toggleSet = new ToggleSettings(toggleSetContainer);
			window.toggleSet.init();
		}
	}

	if (window.IsStoryboard) {
		$(document).bind('DAPI.hFilterLoaded', function () {
			if (typeof (toggleSet) == 'undefined') {
				window.toggleSet = new ToggleSettings('#pnlSettingsPanel, #pageStoryTellerToolbar, #tabholder_cc');
				window.toggleSet.init();
				if (!GeneralSettings.hasGeneralSettings() && !Storyboard.LayoutDesigner.isAdmin)
					window.toggleSet.toggleEl.hide();
			}
		});
	}

	if (window.location.href.indexOf('ReportDistributionModule/RHViewResultOnlineBrand.aspx') > -1) {
		toggleSetContainer = '#filterAndTabNavWrapper';
		if (typeof (Sys) != 'undefined' && Sys.WebForms.PageRequestManager.getInstance() != null) {
			Sys.WebForms.PageRequestManager.getInstance().add_endRequest(staticToggleTools);
		}
	}

	if (window.location.href.indexOf('RHViewOpenAnswersReport.aspx') > -1) {
		toggleSetContainer = '#content.filterListContainer';
		if (typeof (Sys) != 'undefined' && Sys.WebForms.PageRequestManager.getInstance() != null) {
			Sys.WebForms.PageRequestManager.getInstance().add_pageLoaded(staticToggleTools);
			Sys.WebForms.PageRequestManager.getInstance().add_endRequest(staticToggleTools);
		}
	}

	if (window.location.href.indexOf('RHtoplines.aspx') > -1
			|| window.location.href.indexOf('RHcrosstabs.aspx') > -1) {
		toggleSetContainer = '.toggleSettings';
		if (typeof (Sys) != 'undefined' && Sys.WebForms.PageRequestManager.getInstance() != null) {
			Sys.WebForms.PageRequestManager.getInstance().add_pageLoaded(staticToggleTools);
			Sys.WebForms.PageRequestManager.getInstance().add_endRequest(staticToggleTools);
		}
	}

	////////// End Presentation Mode

	// General translations
	function localize() {
		var selectors = [
			"lblHome","lblMyPage","lblLogout"];

		selectors.forEach(function (selector) {
			var $element = $("#" + selector);

			if (!$element.text()) {
				$element = $('[id$=ctl00_' + selector + ']')
			}

			$element.text(locale.get($element.text().trim(), 0));
		});
	}

	localize();

	// Refresh page required info message
	function showRefreshPageMessage() {
		if ($('#refreshPageMessage').length > 0) return;

		$('#pageWrapper').before('<div id="refreshPageMessage" class="Message-fixed-wrapper"><span class="Message Message-error Message-compact">To see the updates in the report menu refresh the page. Do you want to refresh the page now? <button type="button" id="btnRefreshPageNow" class="DUIButton m-x-1">Refresh now</button> <button type="button" id="btnRefreshPageLater" class="DUIButton">Refresh later</button></span></div>');

		$('#btnRefreshPageNow').bind('click', function() {
			window.location.reload();
		});

		$('#btnRefreshPageLater').bind('click', function() {
			$('#refreshPageMessage').remove();
		});
	}

	window.addEventListener('refreshpagemessage', showRefreshPageMessage, false);
});